/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-08-08 10:31:06
 * @LastEditors: K
 * @LastEditTime: 2022-08-08 10:42:43
 */
// 0总药房 1西药房: 2中药房
export enum infoType {
  JGorHZ = 0,
  PTorJG = 1,
  PTorPT = 2,
}

export const infoTypes = [infoType.JGorHZ, infoType.PTorJG, infoType.PTorPT]

export function infoTypeName(smsType: infoType) {
  switch (smsType) {
    case 0:
      return '机构发送给患者'
    case 1:
      return '平台发给机构'
    case 2:
      return '平台发给平台'
  }
}
